import { render, staticRenderFns } from "./AdvantagesComponent.vue?vue&type=template&id=69e1a443&scoped=true&"
import script from "./AdvantagesComponent.vue?vue&type=script&lang=js&"
export * from "./AdvantagesComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdvantagesComponent.vue?vue&type=style&index=0&id=69e1a443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e1a443",
  null
  
)

export default component.exports